<template>
  <div class="app-container">
    <div class="formBox margbot" ref="searchBox">
      <el-form :inline="true" class="demo-form-inline" :model="searchForm" label-width="90px" size="mini">
        <div class="formItemBox">
          <el-form-item label="签收时间:">
            <el-date-picker
              v-model="dateRange"
              type="datetimerange"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              :default-time="['00:00:00', '23:59:59']"
              @change="dateRangeChange"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="分子公司:">
            <el-select v-model="searchForm.companyCode" filterable clearable placeholder="请选择" @change="zigsChangeCX">
              <el-option v-for="item in getCompany" :label="item.companyName" :value="item.companyCode" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="部门:">
            <el-select v-model="searchForm.departmentCode" filterable clearable placeholder="请选择">
              <el-option v-for="item in bumenList" :label="item.name" :value="item.code" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="客户名称:">
            <el-input placeholder="" v-model="searchForm.payee" ></el-input>
          </el-form-item>
          <el-form-item label="超期区间:">
            <el-select v-model="searchForm.overdueDays" placeholder="请选择">
              <el-option label="全部" value=""></el-option>
              <el-option label="超3个月" value="90"></el-option>
              <el-option label="超6个月" value="180"></el-option>
              <el-option label="超9个月" value="270"></el-option>
              <el-option label="超1年以上" value="360"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div style="display: flex;align-items: center;padding-right: 20px;">
          <div class="searchBtnBox" style="flex-shrink:0">
            <el-button type="primary" size="mini" @click="searchFn">查询</el-button>
            <el-button type="primary" size="mini" @click="resetForm">重置</el-button>
            <el-button type="primary" @click="exportFn" size="mini" :disabled="isDaoChu">导出</el-button>
          </div>
        </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{ height: h }">
      <el-table :data="tableList" ref="table" bordersize="mini" height="100%" style="width: 100%" class="tableComent" highlight-current-row
      center border show-summary :summary-method="getSummaries" :span-method="objectSpanMethod">
        <el-table-column type="index" width="55" label="序号"></el-table-column>
        <el-table-column prop="createSubcompanyName" label="分子公司" width="180" :show-overflow-tooltip="true" :formatter="emptyFn"></el-table-column>
        <el-table-column prop="businessUnit" label="部门" width="120" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="payee" label="客户名称" width="230" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="grossRevenue" label="应收款" width="120" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="ykpWsk" label="已开票未收款" min-width="120" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="wkpWsk" label="未开票未收款" min-width="120" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="ykpCq" label="已开超期金额" min-width="120" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="wkpCq" label="未开超期合计" min-width="120" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="zqjsSd" label="账期计算开始日" min-width="120" :show-overflow-tooltip="true" :formatter="emptyFn"></el-table-column>
        <el-table-column prop="ydzq" label="约定账期" min-width="120" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="ykpCqts" label="已开超期天数" min-width="120" :show-overflow-tooltip="true" :formatter="emptyFn"></el-table-column>
        <el-table-column prop="wkpCqts" label="未开超期天数" min-width="120" :show-overflow-tooltip="true" :formatter="emptyFn"></el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import { getBtn } from '@/utils/getButton'
import { getReportYsList } from '@/api/newTMS'
import { emptyFn, toFixed } from '@/utils/util'
import { exportExcel } from '@/utils/fileDownXlsx.js'
import { getCurrUserDepartment, getCurrUserRightCompany } from '@/api/newCrm'
export default {
  name: 'BasicMeterial',
  components: { },
  data () {
    return {
      toFixed: toFixed,
      emptyFn: emptyFn,
      dateRange: [],
      searchForm: {
        payeeType: 1,
        startTimeStr: '',
        endTimeStr: '',
        departmentCode: '',
        companyCode: ''
      },
      tableList: [],
      spanArr: [],
      // 按钮
      btnFlg: [],
      btnIdArr: [],
      h: '',
      isDaoChu: false,
      getCompany: [],
      bumenList: []
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/carStatusDistribution')
    // 初始化默认时间范围（最近30天）
    this.dateRange = this.getDefaultDateRange()
    if (this.dateRange && this.dateRange.length === 2) {
      this.searchForm.startTimeStr = this.dateRange[0]
      this.searchForm.endTimeStr = this.dateRange[1]
    }
    getCurrUserRightCompany().then(res => { this.getCompany = res })
    this.masterList()
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = pH - h - 140 + 'px'
  },
  methods: {
    // 获取默认日期范围（最近30天）
    getDefaultDateRange () {
      const today = new Date()
      const thirtyDaysAgo = new Date()
      thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 29)
      const format = (d) => {
        const y = d.getFullYear()
        const m = String(d.getMonth() + 1).padStart(2, '0')
        const day = String(d.getDate()).padStart(2, '0')
        return `${y}-${m}-${day}`
      }
      return [format(thirtyDaysAgo) + ' 00:00:00', format(today) + ' 23:59:59']
    },
    // 日期范围变化
    dateRangeChange (val) {
      if (!val || val.length !== 2) {
        this.searchForm.startTimeStr = ''
        this.searchForm.endTimeStr = ''
        return
      }
      const [start, end] = val
      // 验证时间跨度不超过1年
      const startDate = new Date(start)
      const endDate = new Date(end)
      const oneYearLater = new Date(startDate)
      oneYearLater.setFullYear(oneYearLater.getFullYear() + 1)
      if (endDate > oneYearLater) {
        this.$message.warning('时间跨度不可超过1年')
        this.dateRange = []
        this.searchForm.startTimeStr = ''
        this.searchForm.endTimeStr = ''
        return
      }
      this.searchForm.startTimeStr = start
      this.searchForm.endTimeStr = end
    },
    // 子公司更改
    zigsChangeCX (e) {
      getCurrUserDepartment({ compayCode: e, isQueryDept: 0 }).then(res => { this.bumenList = res })
      this.searchForm.departmentCode = ''
    },
    // 占比格式化：确保数据行和合计行的占比显示一致
    formatPercent (row, column, cellValue) {
      if (cellValue === null || cellValue === undefined || cellValue === '') return '-'
      const str = String(cellValue)
      if (str.includes('%')) return str
      const num = Number(cellValue)
      if (isNaN(num)) return str
      return toFixed(num, 2) + '%'
    },
    // 指定列求和
    getSummaries (param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '-'
          return
        }
        if (column.property === 'createSubcompanyName') {
          sums[index] = '合计'
          return
        }
        if (['payee', 'businessUnit'].includes(column.property)) {
          sums[index] = '-'
          return
        }
        if (!column.property) {
          sums[index] = '-'
          return
        }
        // 占比列不合计
        if (column.property === 'zqjsSd' || column.property === 'ydzq' || column.property === 'ykpCqts' || column.property === 'wkpCqts') {
          sums[index] = '-'
          return
        }
        // 数值列求和
        const values = data.map(item => Number(item[column.property]))
        sums[index] = values.reduce((prev, curr) => {
          const value = Number(curr)
          if (!isNaN(value)) {
            return prev + curr
          } else {
            return prev
          }
        }, 0)
      })
      // 格式化数值
      return sums.map(item => {
        if (typeof item === 'number') {
          return toFixed(item, 2)
        }
        return item
      })
    },
    // 重新计算高度
    getgaodu () {
      this.$nextTick(() => {
        if (this.$refs.searchBox) {
          let h = this.$refs.searchBox.offsetHeight
          let pH = document.documentElement.clientHeight
          this.h = (pH - h - 140) + 'px'
          if (this.$refs.table) {
            this.$refs.table.doLayout()
          }
        }
      })
    },
    // 合并单元格
    objectSpanMethod ({ row, column, rowIndex, columnIndex }) {
      if (column.property === 'businessUnit' || column.property === 'createSubcompanyName') {
        const _row = this.spanArr[rowIndex]
        const _col = _row > 0 ? 1 : 0
        return {
          rowspan: _row,
          colspan: _col
        }
      } else {
        return [1, 1]
      }
    },
    // 生成合并规则数组（同时按子公司+部门合并）
    getSpanArr (data) {
      this.spanArr = []
      let pos = 0
      data.forEach((item, index) => {
        if (index === 0) {
          this.spanArr.push(1)
          pos = 0
        } else {
          if (item.businessUnit === data[index - 1].businessUnit &&
              item.createSubcompanyName === data[index - 1].createSubcompanyName) {
            this.spanArr[pos] += 1
            this.spanArr.push(0) // 0表示该行被合并
          } else {
            this.spanArr.push(1)
            pos = index
          }
        }
      })
    },
    masterList () {
      const loading = this.$loading({
        lock: true,
        text: '加载中...'
      })
      getReportYsList(this.searchForm)
        .then(res => {
          this.tableList = res || []
          this.getSpanArr(this.tableList)
          this.getgaodu()
          loading.close()
        })
        .catch(err => {
          this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
    },
    searchFn () {
      if (!this.searchForm.startTimeStr || !this.searchForm.endTimeStr) {
        this.$message.warning('请选择时间范围')
        return
      }
      this.masterList()
    },
    // 重置
    resetForm () {
      this.dateRange = this.getDefaultDateRange()
      this.searchForm = {
        startTimeStr: this.dateRange[0],
        endTimeStr: this.dateRange[1],
        departmentCode: '',
        companyCode: '',
        payeeType: 1
      }
      this.bumenList = []
      this.searchFn()
    },
    // 导出
    exportFn () {
      let form = { ...this.searchForm }
      exportExcel(
        this.global.tmsPlus + '/rCustomer/exportReportYsListExcel',
        form,
        '应收账龄统计表'
      )
      this.isDaoChu = true
      setTimeout(() => {
        this.isDaoChu = false
      }, 2000)
    }
  }
}
</script>

<style scoped lang="less">
/deep/ .el-table__footer-wrapper tbody td {
  color: #409EFF;
  font-weight: bold;
}
</style>
